import doc                 from '@widesk-core/decorators/doc';
import Blamable            from '@/models/traits/Blamable';
import AdminServiceModel   from '@/models/AdminServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';

@doc.urnResource('menu')
@doc.path('/menus/{?id}')
@doc.addable
@doc.editable
@doc.deletable
export default class MenuModel extends Blamable(TimestampAble(AdminServiceModel)) {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Admin_MenuReference;
		'label': id;
		'search': string;
	};

	private declare _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Admin_MenuReference;
}
